import React from 'react';

import { currencyFormat } from 'utilities/common';
import { Form } from 'ui/components';

const JobConsole = ({ data, checkedAll, handleCheckedAll, handleChecked }) => {
  if (data?.length === 0) {
    return (
      <div className="row">
        <div className="empty col-lg-12 truck">
          <div className="truck-wrapper">
            <div className="truck">
              <div className="truck-container"></div>
              <div className="glases"></div>
              <div className="bonet"></div>
              <div className="base"></div>
              <div className="base-aux"></div>
              <div className="wheel-back"></div>
              <div className="wheel-front"></div>
              <div className="smoke"></div>
            </div>
          </div>
          <p className="empty-title">Hasil tidak ditemukan</p>
          <p className="empty-subtitle text-muted">
            Coba sesuaikan pencarian atau filter Anda untuk menemukan apa yang
            Anda cari.
            <br /> Atau mungkin belum ada datanya!
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="table-responsive m-0" style={{ maxHeight: 740 }}>
        <table
          width="100%"
          className="table table-hover table-vcenter card-table datatable border"
        >
          <thead className="bg-light">
            <tr className="th">
              <td style={{ width: '20px' }}>
                <Form.Checkbox
                  value={checkedAll}
                  onChange={() => handleCheckedAll(checkedAll ? false : true)}
                  iconSize={18}
                />
              </td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '200px',
                }}
              >
                Shipment
              </td>
              <td style={{ width: '50px' }}>Berat</td>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr key={index} onClick={() => {
                handleChecked(item?.is_checked ? false : true, index)
              }}>
                <td>
                  <Form.Checkbox
                    value={item?.is_checked}
                    iconSize={18}
                  />
                </td>
                <td>
                  <div className="table-col">
                    <small className="info text-ellipsis">
                      {item?.delivery_order?.shipment?.code}
                    </small>
                    <div className="text-ellipsis d-block fs-8 fw-semibold text-uppercase">
                      {item?.delivery_order?.shipment?.destination?.name}
                    </div>
                    <small className="info text-uppercase">
                      {item?.delivery_order?.shipment?.destination?.region?.district_name},{' '}
                      {item?.delivery_order?.shipment?.destination?.region?.regency_name},{' '}
                      {item?.delivery_order?.shipment?.destination?.region?.province_name}
                    </small>
                  </div>
                </td>

                <td style={{ width: '100px' }}>
                  <div className="table-col">
                    <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                      {currencyFormat(
                        item?.delivery_order?.shipment?.total_weight
                      )}{' '}
                      KG
                    </div>
                    <small className="info text-uppercase">
                      {item?.delivery_order?.shipment?.total_quantity} Koli
                    </small>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default JobConsole;
